export const formatDateString = (date: string): string => {
  const newDate = new Date(date);

  return newDate.toLocaleDateString('en-GB');
};
